module.exports = __webpack_public_path__ + "img/order-tab-finished.97c0aea2.png";